import { render, staticRenderFns } from "./rankings.vue?vue&type=template&id=79eb0be9&scoped=true"
import script from "./rankings.vue?vue&type=script&lang=js"
export * from "./rankings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eb0be9",
  null
  
)

export default component.exports